module.exports = __webpack_public_path__ + "static/intro-banner-high-res-f2f7e7165f3622f188e1eac35b893bbf.jpg";